import parse from "url-parse";
import { getContext } from "@src/client/context";
import { RECEIVE_WELCOME_MESSAGE } from "./constants";
import {
  correctInvalidKeyStoreDataversion,
  finishSettingCustomAttributeFromPreviousRequest
} from "./invalidKeyStoreDataversionHandling";

export const requestWelcomeMessage = (
  platform,
  alternateUrls,
  resolvedDeliveryCountry
) => {
  return async (dispatch, getState, { api: { fetchWelcomeMessage } }) => {
    const {
      regionalStore: { countryCode: browseCountry }
    } = getState();

    const context = getContext();
    const geoCountry = context.getGeoCountry();

    fetchWelcomeMessage(
      geoCountry,
      browseCountry,
      platform,
      resolvedDeliveryCountry
    )
      .then(res => {
        finishSettingCustomAttributeFromPreviousRequest();

        if (res.browsingLocalStore) {
          dispatch({ type: RECEIVE_WELCOME_MESSAGE, payload: res });
          return;
        }

        const {
          country: { defaultLanguage }
        } = res;

        const useQuerystringifyParser = true;
        res.redirectUrl.url = parse(
          alternateUrls[defaultLanguage] || `//${res.redirectUrl.url}`,
          useQuerystringifyParser
        );

        dispatch({ type: RECEIVE_WELCOME_MESSAGE, payload: res });
      })
      .catch(error => {
        if (
          error.status === 400 &&
          error.responseText.includes('errorCode":"STR003"')
        ) {
          correctInvalidKeyStoreDataversion();
        }
      });
  };
};
